import React from 'react'
import _ from 'lodash';
import moment from 'moment';
import Slider from 'material-ui/Slider';
import FlexView from 'react-flexview';
import FlatButton from 'material-ui/FlatButton';
import PersonIcon from 'material-ui/svg-icons/social/person';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import Drawer from 'material-ui/Drawer';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import PowerIcon from 'material-ui/svg-icons/action/power-settings-new';
import Badge from 'material-ui/Badge';
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';
import EventNoteIcon from 'material-ui/svg-icons/notification/event-note';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { Tabs, Tab } from 'material-ui/Tabs';
import VolumeUpIcon from 'material-ui/svg-icons/av/volume-up';
import PrintIcon from 'material-ui/svg-icons/action/print';
import AddIcon from 'material-ui/svg-icons/content/add';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import RemoveIcon from 'material-ui/svg-icons/content/remove';
import DoneIcon from 'material-ui/svg-icons/action/done';
import { white, amber400 } from 'material-ui/styles/colors';
import Cookies from 'universal-cookie';
import * as SocketIO from "../common/SocketIO.js";
import * as DataAPI from "../common/DataAPI.js";
import Dialogs from "../common/Dialogs.js";
import * as history from '../common/history.js';
import constants from "../common/constants";

const cookies = new Cookies();

const volumeBarHeight = 110;
const volumeStep = 10;

class Keypad1280x800 extends React.Component {
  constructor(props) {
    super();

    // const query = _.split(_.replace(_.get(props, 'location.search'), '?', ''), '&');

    // let isSupervisor = 'N';
    // _.forEach(query, item => {
    //   if (_.startsWith(item, 'supervisor')) {
    //     isSupervisor = _.last(_.split(item, '='));
    //   }
    // });

    this.state = {
      userId: cookies.get('_id'),
      userName: cookies.get('loginId'),
      ticketsByQueue: [],
      ticketSelected: null,
      isAllowGetTicket: true,
      numberInputted: '',
      ticketStatusToShow: 'pending',
      callingVolume: null,
      isDisableVolumeBtn: false,
      shouldOpenLeftPanel: false,
      counters: [],
      counterSelected: null,
      queues: [],
      queueSelected: null,
      ticketRecords: [],
      shouldShowTicketRecords: false,
      isSupervisor: cookies.get('id') === 'supervisor', // http://url?supervisor=Y
    };

    this.selectTicket = this.selectTicket.bind(this);
    this.callTicket = this.callTicket.bind(this);
    this.processTicket = this.processTicket.bind(this);
    this.updateIsAllowGetTicket = this.updateIsAllowGetTicket.bind(this);
    this.inputNumber = this.inputNumber.bind(this);
    this.clearNumber = this.clearNumber.bind(this);
    this.createTicket = this.createTicket.bind(this);
    this.resetTickets = this.resetTickets.bind(this);
    this.navigateToAdminPanel = this.navigateToAdminPanel.bind(this);
    this.refreshTickets = this.refreshTickets.bind(this);
    this.setConfirmingTicketStatus = this.setConfirmingTicketStatus.bind(this);
    this.setTicketToBePending = this.setTicketToBePending.bind(this);
    this.openLeftPanel = this.openLeftPanel.bind(this);
    this.closeLeftPanel = this.closeLeftPanel.bind(this);
    this.selectCounter = this.selectCounter.bind(this);
    this.selectQueue = this.selectQueue.bind(this);
    this.nextPpl = this.nextPpl.bind(this);
    this.showTicketRecords = this.showTicketRecords.bind(this);
    this.hideTicketRecords = this.hideTicketRecords.bind(this);
    this.fetchTicketRecords = this.fetchTicketRecords.bind(this);
  }

  componentWillMount() {
    if (!this.state.userId) {
      history.push('/keypad-login');
    }
    // this.refreshTickets(() => {
    // _.forEach(this.ticketsCalledRefs, (ref) => {
    //   if (ref) ref.scrollLeft += 99999;
    // });
    // });
    // this.getKioskInfo();
    this.getCounterList(() => {
      const counterId = window.localStorage.getItem('counterId');
      if (counterId) this.selectCounter(null, counterId);
    });
    this.getQueueList(() => {
      this.selectQueue(null, _.get(_.head(this.state.queues), '_id'));
    });
    this.fetchTicketRecords();
  }

  componentDidMount() {
    SocketIO.on('refresh', () => {
      location.reload();
    });

    SocketIO.on('refreshTickets', () => {
      this.refreshTickets();
    });

    SocketIO.on('refreshQueue', ({}) => {
      this.getQueueList(() => {
        this.selectQueue(null, _.get(_.head(this.state.queues), '_id'));
      });
    });

    SocketIO.on('refreshPendingTickets', ({ shouldScrollToRight, queueId }) => {
      this.refreshTickets();
    });

    SocketIO.on('refreshQueue', msg => {
      this.refreshTickets();
    });

    if (constants.canViewTicketHistory) {
      SocketIO.on('refreshTicketRecords', this.fetchTicketRecords.bind(this, 1));
    }

    // SocketIO.on('calling', ({ shouldScrollToRight, ticketToCall }) => {
    //   const ticketsByQueue = _.map(_.cloneDeep(this.state.ticketsByQueue), item => {
    //     if (_.get(item, 'queue._id') !== ticketToCall.queue) return item;
    //
    //     let pendingTickets = _.cloneDeep(item.pendingTickets);
    //     let ticketsCalled = _.cloneDeep(item.ticketsCalled);
    //
    //     if (_.get(item.callingTicket, 'status') === 'pending') {
    //       pendingTickets.push(item.callingTicket);
    //       pendingTickets = _.sortBy(pendingTickets, ['number']);
    //     } else if (_.indexOf(['invalid', 'processed'], _.get(item.callingTicket, 'status')) !== -1) {
    //       ticketsCalled.push(item.callingTicket);
    //       ticketsCalled = _.sortBy(ticketsCalled, ['number']);
    //     }
    //
    //     _.remove(ticketsCalled, { _id: ticketToCall._id });
    //     _.remove(pendingTickets, { _id: ticketToCall._id });
    //
    //     return _.assign(item, {
    //       pendingTickets,
    //       ticketsCalled,
    //       callingTicket: this.formatTicket(ticketToCall),
    //     });
    //   });
    //
    //   this.setState({
    //     ticketsByQueue,
    //   }, () => {
    //     // if (shouldScrollToRight) {
    //     //   this.ticketsCalledRefs[ticketToCall.queue].scrollLeft += 99999;
    //     // }
    //   });
    // });
  }

  componentWillUnmount() {
    SocketIO.removeAllListeners('refresh');
    SocketIO.removeAllListeners('refreshPendingTickets');
    SocketIO.removeAllListeners('refreshQueue');
    SocketIO.removeAllListeners('calling');
  }

  getQueueList(cb) {
    DataAPI.get('/api/keypad/queueList', null, (err, queues) => {
      if (err) return this.dialogs.error(err);

      queues = _.concat({
        _id: '',
        code: '全部',
      }, queues);

      this.setState({
        queues,
      }, cb)
    });
  }

  resetTickets() {
    this.dialogs.confirm({
      title: '確認重置叫號？',
    }, () => {
      DataAPI.put('/api/keypad/resetTickets', null, (err) => {
        if (err) return this.dialogs.error(err);
      });
    });
  };

  fetchTicketRecords(day = 1) {
    DataAPI.get(`/api/keypad/ticketRecords/${day}`, {}, (err, ticketRecords) => {
      if (err) return this.dialogs.error(err);

      let currentTicketRecords = _.cloneDeep(this.state.ticketRecords);

      _.forEach(ticketRecords, newTicketRecord => {
        const currentTicketRecord = _.find(currentTicketRecords, { date: newTicketRecord.date });

        if (currentTicketRecord) {
          _.set(currentTicketRecord, 'records', newTicketRecord.records);
        } else {
          currentTicketRecords.push(newTicketRecord)
        }
      });

      currentTicketRecords = _.reverse(_.sortBy(currentTicketRecords, 'date'));

      this.setState({
        ticketRecords: currentTicketRecords,
      });
    });
  }

  createTicket(queue) {
    DataAPI.put(`/api/keypad/${queue._id}/createTicket`, {}, (err, ticket) => {
      if (err) return this.dialogs.error(err);

      this.dialogs.alert({
        title: '新籌號: ' + ticket.queue.code + this.formatTicket(ticket).number,
      });
    });
  }

  getKioskInfo() {
    DataAPI.get('/api/keypad/kiosk', {}, (err, display) => {
      if (err) return this.dialogs.error(err);

      this.setState({
        callingVolume: display.callingVolume,
      });
    });
  }

  getCounterList(cb) {
    DataAPI.get('/api/keypad/counterList', {}, (err, counters) => {
      if (err) return this.dialogs.error(err);

      this.setState({
        counters,
      }, cb);
    });
  }

  showTicketRecords() {
    this.setState({
      shouldShowTicketRecords: true,
    });
  }

  hideTicketRecords() {
    this.setState({
      shouldShowTicketRecords: false,
    });
  }

  selectTicket(ticketToSelect, cb = constants.emptyFnc) {
    // const currentTicketsByQueue = _.cloneDeep(this.state.ticketsByQueue);
    // // Add '0' to ticket number
    // let ticketsByQueue = _.map(currentTicketsByQueue, (ticketByQueue, index) => {
    //   if (_.get(ticketByQueue, 'queue._id') !== ticketToSelect.queue) return ticketByQueue;
    //
    //   return _.assign({}, ticketByQueue, {
    //     ticketSelected: _.get(ticketByQueue.ticketSelected, '_id') === ticketToSelect._id ? null : ticketToSelect,
    //   });
    // });

    // this.setState({
    //   ticketsByQueue,
    // }, cb);

    if (_.get(this.state.ticketSelected, '_id') === ticketToSelect._id) {
      this.deselectTicket();
    } else {
      this.setState({
        ticketSelected: ticketToSelect,
      }, cb);
    }
  }

  deselectTicket(cb = constants.emptyFnc) {
    // const currentTicketsByQueue = _.cloneDeep(this.state.ticketsByQueue);
    // // Add '0' to ticket number
    // let ticketsByQueue = _.map(currentTicketsByQueue, (ticketByQueue, index) => {
    //   if (_.get(ticketByQueue, 'queue._id') !== queue._id) return ticketByQueue;
    //
    //   return _.assign({}, ticketByQueue, {
    //     ticketSelected: null,
    //   });
    // });
    //
    // this.setState({
    //   ticketsByQueue,
    // }, cb);

    this.setState({
      ticketSelected: null,
    }, cb);
  }

  removeCallingTicket(queue, cb = constants.emptyFnc) {
    const currentTicketsByQueue = _.cloneDeep(this.state.ticketsByQueue);
    // Add '0' to ticket number
    let ticketsByQueue = _.map(currentTicketsByQueue, (ticketByQueue, index) => {
      if (_.get(ticketByQueue, 'queue._id') !== queue._id) return ticketByQueue;

      return _.assign({}, ticketByQueue, {
        callingTicket: null,
      });
    });

    this.setState({
      ticketsByQueue,
    }, cb);
  }

  callTicket({ ticketSelected, pendingTickets, ticketsCalled, language }) {
    if (!this.state.counterSelected) return this.dialogs.error('請先選擇櫃檯');

    if (ticketSelected) {
      const allTickets = _.concat(pendingTickets, ticketsCalled);

      const ticket = _.find(allTickets, ticket => {
        return ticket._id === ticketSelected._id;
      });

      if (!ticket) return this.deselectTicket();
    }

    if (ticketSelected) {
      DataAPI.post(`/api/keypad/callTicket/${this.state.userId}/${this.state.counterSelected._id}/${ticketSelected._id}`, {
        language,
      }, (err, ticketCalled) => {
        if (err) {
          this.deselectTicket();
          return this.dialogs.error(err);
        }
      });
    } else {
      const ticketToSelect = _.head(pendingTickets);

      if (!ticketToSelect) return;

      this.selectTicket(ticketToSelect, () => {
        DataAPI.post(`/api/keypad/callTicket/${this.state.userId}/${this.state.counterSelected._id}/${ticketToSelect._id}`, {
          language,
        }, (err, ticketCalled) => {
          if (err) {
            this.deselectTicket();
            return this.dialogs.error(err);
          }
        });
      });
    }
  }

  setConfirmingTicketStatus(queue, isConfirmingTicketStatus) {
    const ticketsByQueue = _.map(_.cloneDeep(this.state.ticketsByQueue), item => {
      if (_.get(item, 'queue._id') === queue._id) _.set(item, 'isConfirmingTicketStatus', isConfirmingTicketStatus);

      return item;
    });

    this.setState({
      ticketsByQueue,
    });
  }

  setTicketToBeInvalid({ ticketSelected }) {
    this.deselectTicket(() => {
      DataAPI.post(`/api/keypad/ticketToInvalid/${this.state.userId}/${this.state.counterSelected._id}/${ticketSelected._id}`, {}, (err, ticketInvalided) => {
        if (err) return this.dialogs.error(err);
      });
    });
  }

  processTicket({ ticketSelected }) {
    this.deselectTicket(() => {
      DataAPI.post(`/api/keypad/processTicket/${this.state.userId}/${this.state.counterSelected._id}/${ticketSelected._id}`, {}, (err, ticketProcessed) => {
        if (err) return this.dialogs.error(err);
      });
    });
  }

  deleteTicket({ ticketSelected }) {
    this.dialogs.confirm({
      title: '確認刪除籌號？',
    }, () => {
      this.deselectTicket(() => {
        DataAPI.post(`/api/keypad/deleteTicket/${this.state.userId}/${this.state.counterSelected._id}/${ticketSelected._id}`, {}, (err, ticketDeleted) => {
          if (err) return this.dialogs.error(err);
        });
      });
    });
  }

  setTicketToBePending({ ticketSelected }) {
    this.deselectTicket(() => {
      DataAPI.post(`/api/keypad/ticketToPending/${this.state.userId}/${this.state.counterSelected._id}/${ticketSelected._id}`, {}, (err, pendingTicket) => {
        if (err) return this.dialogs.error(err);
      });
    });
  }

  notifyKioskToUpdateLayer() {
    DataAPI.post('/api/keypad/updateKioskLayer', {
      isAllowGetTicket: this.state.isAllowGetTicket,
    }, (err) => {
      if (err) return this.dialogs.error(err);
    });
  }

  updateIsAllowGetTicket(isAllowed) {
    this.setState({
      isAllowGetTicket: isAllowed,
    }, this.notifyKioskToUpdateLayer);
  }

  inputNumber(number) {
    this.setState((prevState) => {
      if (!_.size(_.toString(prevState.numberInputted)) && number === 0) return false;

      const newNumber = _.toNumber(prevState.numberInputted + _.toString(number));

      if (newNumber > constants.maxNumberOfPeople) return false;

      return {
        numberInputted: newNumber,
      }
    });
  }

  clearNumber() {
    this.setState({
      numberInputted: '',
    });
  }

  formatTicket(ticket) {
    return _.assign(ticket, {
      number: _.padStart(ticket.number, constants.numberOfTicketDigit, 0),
      createdAtTime: moment(ticket.createdAt).format('HH:mm'),
    });
  }

  refreshTickets(cb = constants.emptyFnc) {
    DataAPI.get(`/api/keypad/ticketsByQueue`, {
      queueId: this.state.queueSelected._id,
    }, (err, newTicketsByQueue) => {
      if (err) return this.dialogs.error(err);

      const currentTicketsByQueue = _.cloneDeep(this.state.ticketsByQueue);
      // Add '0' to ticket number
      let ticketsByQueue = _.compact(_.map(_.range(constants.maxNumberOfQueues), index => {
        const newTicketByQueue = newTicketsByQueue[index];
        const currentTicketByQueue = currentTicketsByQueue[index];

        if (!newTicketByQueue) return null;

        let pendingTickets = _.cloneDeep(newTicketByQueue.pendingTickets);
        // _.remove(pendingTickets, { _id: _.get(currentTicketByQueue, 'callingTicket._id') });

        let ticketsCalled = _.cloneDeep(newTicketByQueue.ticketsCalled);
        // Filter counter & status
        if (!this.state.isSupervisor) {
          ticketsCalled = _.filter(ticketsCalled, ticket => {
            return (constants.showInvalidTicketOfOtherCounter && ticket.status === 'invalid') || _.get(ticket.counter, '_id') === _.get(this.state.counterSelected, '_id');
          });
        }

        return _.assign({}, currentTicketByQueue, {
          queue: newTicketByQueue.queue,
          pendingTickets: _.map(pendingTickets, this.formatTicket),
          ticketsCalled: _.map(ticketsCalled, this.formatTicket),
        });
      }));


      let pendingTickets, ticketsCalled;

      if (_.size(this.state.queueSelected._id)) {
        const item = _.find(ticketsByQueue, (obj) => {
          return obj.queue._id === this.state.queueSelected._id;
        });

        pendingTickets = item.pendingTickets;
        ticketsCalled = item.ticketsCalled;
      } else {
        pendingTickets = _.chain(ticketsByQueue)
          .map('pendingTickets')
          .flatten()
          .value();

        ticketsCalled = _.chain(ticketsByQueue)
          .map('ticketsCalled')
          .flatten()
          .value();
      }

      pendingTickets = _.sortBy(pendingTickets, ['createdAt']);
      ticketsCalled = _.reverse(_.sortBy(ticketsCalled, ['createdAt']));

      // if (this.state.ticketSelected && _.find(ticketsCalled, { _id: this.state.ticketSelected._id })) {
      //   _.remove(ticketsCalled, (ticket) => {
      //     return ticket._id === this.state.ticketSelected._id;
      //   });
      //
      //   ticketsCalled = _.concat(this.state.ticketSelected, ticketsCalled);
      // }

      if (this.state.ticketSelected) {
        const allTickets = _.concat(pendingTickets, ticketsCalled);

        const ticket = _.find(allTickets, ticket => {
          return ticket._id === this.state.ticketSelected._id;
        });

        if (!ticket) this.deselectTicket();
      }

      this.setState({
        ticketsByQueue,
        pendingTickets,
        ticketsCalled,
      }, cb);
    });
  }

  navigateToAdminPanel() {
    history.replace('/adminPanel');
  }

  getQueueName(numberOfPeople) {
    let name = '';

    // if (numberOfPeople.min === numberOfPeople.max) {
    //   name = numberOfPeople.min + '位';
    // } else if (numberOfPeople.max > constants.maxNumberOfPeople) {
    //   name = numberOfPeople.min + '位或以上';
    // } else {
    //   name = numberOfPeople.min + '位至' + numberOfPeople.max + '位';
    // }

    return name;
  }

  updateCallingVolume(action) {
    if (this.state.isDisableVolumeBtn) return;
    if (action === 'up' && this.state.callingVolume >= 100) return;
    if (action === 'down' && this.state.callingVolume <= 0) return;

    const callingVolume = action === 'up' ? this.state.callingVolume + volumeStep : this.state.callingVolume - volumeStep;

    this.setState({
      isDisableVolumeBtn: true,
    }, () => {
      DataAPI.post('/api/keypad/updateCallingVolume/' + callingVolume, {}, (err) => {
        if (err) return this.dialogs.error(err);

        this.setState({
          callingVolume,
          isDisableVolumeBtn: false,
        });
      });
    });
  }

  // setTicketStatusSelected(status) {
  //   if (this.state.ticketStatusSelected !== status) {
  //     this.clearTicketSelected(() => {
  //       this.setState({
  //         ticketStatusSelected: status,
  //       }, () => {
  //         this.refreshTickets(status);
  //       });
  //     });
  //   }
  // }

  openLeftPanel() {
    this.setState({
      shouldOpenLeftPanel: true,
    });
  }

  closeLeftPanel() {
    this.setState({
      shouldOpenLeftPanel: false,
    });
  }

  selectCounter(event, value) {
    const counter = _.find(this.state.counters, { _id: value });

    this.setState({
      counterSelected: counter,
    });

    window.localStorage.setItem('counterId', value);
  }

  selectQueue(event, value) {
    const queue = _.find(this.state.queues, { _id: value });

    this.deselectTicket();
    this.setState({
      queueSelected: queue,
    }, () => {
      this.refreshTickets();
    });
  }

  nextPpl() {
    DataAPI.post('/api/keypad/nextPpl', {
      counter: this.state.counterSelected,
    }, (err) => {
      if (err) return this.dialogs.error(err);
    });
  }

  getTicketRecordTabName(date) {
    let name;

    if (moment().isSame(date, 'day')) {
      name = '今天';
    } else if (moment().subtract(1, 'days').isSame(date, 'day')) {
      name = '昨天';
    } else {
      name = moment(date).format('YYYY-MM-DD');
    }

    return name;
  }

  getActionName(action) {
    return {
      create: '開始輪候',
      call: '叫號',
      invalid: '沒有出現',
      process: '完成',
      delete: '刪除',
      reQueuing: '重新輪候',
    }[action];
  }

  logout() {
    cookies.remove('_id');
    cookies.remove('id');

    history.push('/keypad-login');
  }

  render() {
    this.ticketsCalledRefs = {};

    return (
      <div className="keypad-1280x800-container">
        {
          this.state.shouldShowTicketRecords &&
          <div className="ticket-histories-block">
            <div className="layer" />
            <CancelIcon className="close-icon" onClick={this.hideTicketRecords} />
            <div className="histories-block">
              <Tabs className="tabs-block"
                    inkBarStyle={{
                      backgroundColor: amber400,
                    }}
                    tabItemContainerStyle={{
                      backgroundColor: 'black',
                    }}
                    contentContainerClassName="contents-block">
                {
                  _.map(this.state.ticketRecords, (ticketRecord, tabIndex) => (
                    <Tab label={this.getTicketRecordTabName(ticketRecord.date)}
                         buttonStyle={{ fontSize: 16 }} key={tabIndex}>
                      <div className="content-block">
                        <Table
                          selectable={false}
                          className="table-block"
                          bodyStyle={{
                            height: 508,
                            overflow: 'scroll',
                          }}>
                          <TableHeader
                            adjustForCheckbox={false}
                            displaySelectAll={false}>
                            <TableRow>
                              <TableHeaderColumn>票號</TableHeaderColumn>
                              <TableHeaderColumn>日期</TableHeaderColumn>
                              <TableHeaderColumn>時間</TableHeaderColumn>
                              <TableHeaderColumn>用戶</TableHeaderColumn>
                              <TableHeaderColumn>櫃枱</TableHeaderColumn>
                              <TableHeaderColumn>行動</TableHeaderColumn>
                            </TableRow>
                          </TableHeader>
                          <TableBody displayRowCheckbox={false}>
                            {
                              _.map(ticketRecord.records, (record, rowIndex) => (
                                <TableRow key={rowIndex} displayBorder={false}>
                                  <TableRowColumn>
                                    {record.ticket.queue.code + _.padStart(record.ticket.number, constants.numberOfTicketDigit, '0')}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {moment(record.createdAt).format('YYYY-MM-DD')}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {moment(record.createdAt).format('HH:mm:ss')}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {_.get(record, 'user.loginId')}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {_.get(record, 'counter.name')}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {this.getActionName(record.action)}
                                  </TableRowColumn>
                                </TableRow>
                              ))
                            }
                          </TableBody>
                        </Table>
                      </div>
                    </Tab>
                  ))
                }
              </Tabs>
            </div>
          </div>
        }
        <Drawer open={this.state.shouldOpenLeftPanel} className="left-panel-block"
                containerClassName="left-panel-container">
          <div className="queue-body-left-block">
            <div className="left-panel-header-block">
              <CloseIcon className="close-icon" onClick={this.closeLeftPanel} />
            </div>
            <FlexView className="function-block">
              <FlexView column>
                <div className="function-left-block">

                  <div className="user-block">
                    <PersonIcon className="icon" />
                    <div className="user-name">{this.state.userName}</div>
                    <FlatButton
                      label="登出"
                      onClick={this.logout}
                      className="logout-btn"
                    />
                  </div>

                  {
                    !this.state.isSupervisor &&
                    <div className="counters-block">
                      <div className="title">櫃檯</div>
                      <RadioButtonGroup
                        name="counters"
                        valueSelected={this.state.counterSelected ? _.get(this.state.counterSelected, '_id') : ''}
                        onChange={this.selectCounter}
                        className="radio-group-block">
                        {
                          _.map(this.state.counters, (counter, index) => (
                            <RadioButton
                              key={index}
                              value={counter._id}
                              label={counter.name}
                              labelStyle={{
                                color: 'white',
                              }}
                              className="radio-block"
                            />
                          ))
                        }
                      </RadioButtonGroup>
                    </div>
                  }


                  {/*<div className="ticket-mode-block">*/}
                  {/*<div className="title">取票</div>*/}

                  {/*<div className="mode-block">*/}
                  {/*<div className="on-off-block">*/}
                  {/*<FlatButton*/}
                  {/*label="開啟"*/}
                  {/*className={this.state.isAllowGetTicket ? 'active' : ''}*/}
                  {/*onClick={this.updateIsAllowGetTicket.bind(this, true)}*/}
                  {/*/>*/}
                  {/*<FlatButton*/}
                  {/*label="暫停"*/}
                  {/*className={this.state.isAllowGetTicket ? '' : 'active'}*/}
                  {/*onClick={this.updateIsAllowGetTicket.bind(this, false)}*/}
                  {/*/>*/}
                  {/*</div>*/}
                  {/*</div>*/}
                  {/*</div>*/}
                  {/*<div className="refresh-block">*/}
                  {/*<FlatButton*/}
                  {/*label="重置叫號"*/}
                  {/*className="refresh-ticket-button"*/}
                  {/*onClick={this.resetTickets}*/}
                  {/*icon={<RefreshIcon className="icon" />}*/}
                  {/*/>*/}
                  {/*</div>*/}
                </div>
              </FlexView>
            </FlexView>

            {/*<div className="keyboard-block">*/}
            {/*<div className="number-output-block">*/}
            {/*<div className="label">人數</div>*/}
            {/*<div className="number">{this.state.numberInputted}</div>*/}
            {/*</div>*/}
            {/*<FlexView className="keyboard-keypad-block">*/}
            {/*<FlexView column className="keyboard-body-block">*/}
            {/*{*/}
            {/*_.map(_.range(3), (row, rowIndex) => (*/}
            {/*<FlexView className="keys-block" key={rowIndex}>*/}
            {/*{*/}
            {/*_.map(_.range((row * 3) + 1, (row * 3) + 4), (key, index) => (*/}
            {/*<FlexView column grow={1} shrink={1} basis='100%'*/}
            {/*onClick={this.inputNumber.bind(this, key)}*/}
            {/*className="key-block" key={index}>{key}</FlexView>*/}
            {/*))*/}
            {/*}*/}
            {/*</FlexView>*/}
            {/*))*/}
            {/*}*/}
            {/*<FlexView className="keys-block">*/}
            {/*<FlexView column grow={1} shrink={1} basis='100%'*/}
            {/*onClick={this.inputNumber.bind(this, 0)}*/}
            {/*className="key-block">0</FlexView>*/}
            {/*<FlexView column grow={1} shrink={2} basis='100%'*/}
            {/*onClick={this.clearNumber}*/}
            {/*className="key-block clear-btn">清除</FlexView>*/}
            {/*</FlexView>*/}
            {/*<div className="keyboard-bottom-block">*/}
            {/*<FlatButton*/}
            {/*label="列印發票"*/}
            {/*icon={<PrintIcon className="icon" />}*/}
            {/*className="print-btn"*/}
            {/*disabled={!_.toNumber(this.state.numberInputted)}*/}
            {/*onClick={this.createTicket.bind(this, this.state.numberInputted)}*/}
            {/*fullWidth={true}*/}
            {/*/>*/}
            {/*</div>*/}
            {/*</FlexView>*/}
            {/*</FlexView>*/}
            {/*</div>*/}

          </div>
        </Drawer>
        <FlexView className="keypad-header">
          <FlexView column vAlignContent="center" className="logo-block">
            <div>
              {
                // !this.state.isSupervisor &&
                <MenuIcon className="menu-icon" onClick={this.openLeftPanel} />
              }
              <img src="./images/lemondice-yellow-transparent.png" />
            </div>
          </FlexView>
          <FlexView column marginLeft="auto">
            <FlexView className="button-block" vAlignContent="center">
              {/*<FlatButton*/}
              {/*label="設定"*/}
              {/*icon={<SettingsIcon />}*/}
              {/*onClick={this.navigateToAdminPanel}*/}
              {/*/>*/}
              {/*<FlatButton*/}
              {/*label="登出"*/}
              {/*icon={<PowerIcon />}*/}
              {/*/>*/}
              {
                constants.canViewTicketHistory &&
                <FlatButton
                  label={'查看紀錄'}
                  icon={<EventNoteIcon />}
                  onClick={this.showTicketRecords}
                />
              }
            </FlexView>
          </FlexView>
        </FlexView>

        <FlexView className="keypad-body">
          <FlexView column className="keypad-body-block">
            <div className="queue-block">
              <FlexView className="queue-body-block">
                <div className="queue-body-right-block">
                  <div className="keypad-upper-block">
                    {/*<div className="counters-block">*/}
                    {/*<div className="text">櫃枱</div>*/}
                    {/*<RadioButtonGroup*/}
                    {/*name="counters"*/}
                    {/*valueSelected={this.state.counterSelected ? _.get(this.state.counterSelected, '_id') : ''}*/}
                    {/*onChange={this.selectCounter}*/}
                    {/*className="radio-group-block">*/}
                    {/*{*/}
                    {/*_.map(this.state.counters, (counter, index) => (*/}
                    {/*<RadioButton*/}
                    {/*key={index}*/}
                    {/*value={counter._id}*/}
                    {/*label={counter.name}*/}
                    {/*labelStyle={{*/}
                    {/*color: 'white',*/}
                    {/*}}*/}
                    {/*className="radio-block"*/}
                    {/*/>*/}
                    {/*))*/}
                    {/*}*/}
                    {/*</RadioButtonGroup>*/}
                    {/*</div>*/}
                    <div className="queues-block">
                      <div className="text">隊伍</div>
                      <RadioButtonGroup
                        name="counters"
                        valueSelected={this.state.queueSelected ? _.get(this.state.queueSelected, '_id') : ''}
                        onChange={this.selectQueue}
                        className="radio-group-block">
                        {
                          _.map(this.state.queues, (queue, index) => (
                            <RadioButton
                              key={index}
                              value={queue._id}
                              label={queue.code}
                              labelStyle={{
                                color: 'white',
                              }}
                              className="radio-block"
                            />
                          ))
                        }
                      </RadioButtonGroup>

                      {/*<div className="create-ticket-button-block">*/}
                      {/*{*/}
                      {/*!this.state.isSupervisor &&*/}
                      {/*<FlatButton*/}
                      {/*label="新籌號"*/}
                      {/*icon={<AddIcon className="icon" />}*/}
                      {/*disabled={!_.size(_.get(this.state.queueSelected, '_id'))}*/}
                      {/*onClick={this.createTicket.bind(this, this.state.queueSelected)}*/}
                      {/*/>*/}
                      {/*}*/}
                      {/*</div>*/}

                    </div>

                    <div className="called-tickets-block">
                      <div className="title">已叫號</div>

                      <div className="tickets-block">
                        {
                          _.map(this.state.ticketsCalled, (ticket, ticketIndex) => (
                            <div
                              className={(ticket._id === _.get(this.state.ticketSelected, '_id') ? 'ticket-selected ' : '') + 'ticket-block hv-counter-block'}
                              key={ticketIndex}
                              onClick={!this.state.isSupervisor && this.selectTicket.bind(this, ticket, constants.emptyFnc)}>
                              <div className="ticket-number">
                                {
                                  ticket.status === 'processed' ?
                                    <DoneIcon className="icon" /> :
                                    (ticket.status === 'invalid' ?
                                        <CloseIcon className="icon" /> :
                                        <VolumeUpIcon className="icon" />
                                    )
                                }
                                <span
                                  className="hv-icon">{ticket.queue.code + ticket.number}</span>
                              </div>
                              <div className="ticket-counter-block">
                                {
                                  _.get(ticket, 'counter._id') && <div>櫃枱{ticket.counter.name}</div>
                                }

                              </div>
                              <div className="ticket-info">
                                {/*<div className="ticket-number-of-people">*/}
                                {/*<PersonIcon className="icon" />*/}
                                {/*<div*/}
                                {/*className="number">{ticket.numberOfPeople}</div>*/}
                                {/*</div>*/}
                                <div className="ticket-created-time">
                                  <PrintIcon className="icon" />
                                  <div className="time">{ticket.createdAtTime}</div>
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    </div>

                    <div className="pending-tickets-block">
                      <div className="title">輪候中</div>

                      <div className="tickets-block">
                        {
                          _.map(this.state.pendingTickets, (ticket, ticketIndex) => (
                            <div
                              className={(ticket._id === _.get(this.state.ticketSelected, '_id') ? 'ticket-selected ' : '') + 'ticket-block'}
                              key={ticketIndex}
                              onClick={!this.state.isSupervisor && this.selectTicket.bind(this, ticket, constants.emptyFnc)}
                            >
                              <div className="ticket-number">
                                <span>{ticket.queue.code + ticket.number}</span>
                              </div>
                              <div className="ticket-info">
                                {/*<div className="ticket-number-of-people">*/}
                                {/*<PersonIcon className="icon" />*/}
                                {/*<div*/}
                                {/*className="number">{ticket.numberOfPeople}</div>*/}
                                {/*</div>*/}
                                <div className="ticket-created-time">
                                  <PrintIcon className="icon" />
                                  <div className="time">{ticket.createdAtTime}</div>
                                </div>
                              </div>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                    <div className="result-button-block">
                      {
                        !this.state.isSupervisor &&
                        <div>
                          <FlatButton
                            label="叫號"
                            icon={<VolumeUpIcon className="icon" />}
                            onClick={this.callTicket.bind(this, {
                              ticketSelected: this.state.ticketSelected,
                              ticketsCalled: this.state.ticketsCalled,
                              pendingTickets: this.state.pendingTickets,
                              // language: 'zhHK',
                            })}
                          />
                          {/*<FlatButton*/}
                          {/*label="普"*/}
                          {/*icon={<VolumeUpIcon className="icon" />}*/}
                          {/*onClick={this.callTicket.bind(this, {*/}
                          {/*ticketSelected: this.state.ticketSelected,*/}
                          {/*pendingTickets: this.state.pendingTickets,*/}
                          {/*language: 'zhCN',*/}
                          {/*})}*/}
                          {/*/>*/}
                          {/*<FlatButton*/}
                          {/*label="英"*/}
                          {/*icon={<VolumeUpIcon className="icon" />}*/}
                          {/*onClick={this.callTicket.bind(this, {*/}
                          {/*ticketSelected: this.state.ticketSelected,*/}
                          {/*pendingTickets: this.state.pendingTickets,*/}
                          {/*language: 'en',*/}
                          {/*})}*/}
                          {/*/>*/}
                          <FlatButton
                            label="完成"
                            icon={<DoneIcon className="icon" />}
                            disabled={!this.state.ticketSelected}
                            onClick={this.state.ticketSelected && this.processTicket.bind(this, { ticketSelected: this.state.ticketSelected })}
                          />
                          <FlatButton
                            label="沒有出現"
                            icon={<CloseIcon className="icon" />}
                            disabled={!this.state.ticketSelected}
                            onClick={this.state.ticketSelected && this.setTicketToBeInvalid.bind(this, { ticketSelected: this.state.ticketSelected })}
                          />
                          {/*<FlatButton*/}
                          {/*label="刪除"*/}
                          {/*icon={<DeleteIcon className="icon" />}*/}
                          {/*disabled={!this.state.ticketSelected}*/}
                          {/*onClick={this.state.ticketSelected && this.deleteTicket.bind(this, { ticketSelected: this.state.ticketSelected })}*/}
                          {/*/>*/}
                          <FlatButton
                            label="輪候"
                            disabled={!this.state.ticketSelected}
                            onClick={this.state.ticketSelected && this.setTicketToBePending.bind(this, { ticketSelected: this.state.ticketSelected })}
                          />
                          {/*<FlatButton*/}
                          {/*label="下一位"*/}
                          {/*onClick={this.nextPpl}*/}
                          {/*/>*/}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </FlexView>
            </div>
          </FlexView>
        </FlexView>
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
      </div>
    );
  }
}

export default Keypad1280x800;



// WEBPACK FOOTER //
// client/keypad/Keypad-1280x800.js